import { gql } from "@apollo/client";

export const CeremoniesQuery = gql`
  query GetCeremonies($cursor: String = null) {
    ceremonies(first: 100, after: $cursor) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        slug
      }
    }
  }
`;